/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Future from './Future/index'
import No from './No/index'
import Past from './Past/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Indicator"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentBookingValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
path: 'booking',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: appointmentBookingValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Past'}>
<Past
  viewPath={`${viewPath}/Past`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Future'}>
<Future
  viewPath={`${viewPath}/Future`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}